import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    creating: -1,
    approving: -1,
    saving: -1,
    getSignature: -1,
    voidMC: -1,
    latestCert: -1,
    getDetail: -1,
  },
  data: {},
  signature: {},
  latestCertification: {},
  detailCertification: {},
  latestCert: null,
  meta: {
    pagination: {
      next: null,
      page: 0,
      total: 0,
    },
  },
  list: [],
  error: null,
  errors: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    // create certification
    case ACTION_TYPES.CERTIFICATION_CREATED_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 0,
        },
      };
    case ACTION_TYPES.CERTIFICATION_CREATED_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 1,
        },
        data: { ...state.data, ...payload.data },
        list: [payload.data, ...state.list],
      };
    case ACTION_TYPES.CERTIFICATION_CREATED_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 2,
        },
        error: error?.data?.message || 'Cannot create certification',
      };

    // get list cert
    case ACTION_TYPES.CERTIFICATIONS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.CERTIFICATIONS_RETRIEVE_SUCCEED: {
      const {
        meta: { isLoadMore },
      } = action;
      return {
        ...state,
        status: {
          loading: 1,
        },
        list: isLoadMore ? [...state.list, ...payload.data] : payload.data,
        meta: payload.meta,
      };
    }
    case ACTION_TYPES.CERTIFICATIONS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };

    case ACTION_TYPES.CERTIFICATION_GET_LATEST_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          latestCert: 0,
        },
      };
    case ACTION_TYPES.CERTIFICATION_GET_LATEST_SUCCEED: {
      return {
        ...state,
        status: {
          latestCert: 1,
        },
        latestCert: payload.data,
      };
    }
    case ACTION_TYPES.CERTIFICATION_GET_LATEST_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };

    case ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          latestCertification: 0,
        },
      };
    case ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_SUCCEED: {
      return {
        ...state,
        status: {
          latestCertification: 1,
        },
        latestCertification: payload.data,
      };
    }
    case ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };

    case ACTION_TYPES.CERTIFICATION_VOID_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          voidMC: 0,
        },
      };
    case ACTION_TYPES.CERTIFICATION_VOID_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          voidMC: 1,
        },
      };
    }

    case ACTION_TYPES.CERTIFICATION_VOID_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          voidMC: 2,
        },
        errors: {
          ...state.errors,
          voidMC: error,
        },
      };

    // getCertDetail
    case ACTION_TYPES.CERTIFICATION_GET_DETAIL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetail: 0,
        },
      };

    case ACTION_TYPES.CERTIFICATION_GET_DETAIL_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetail: 1,
        },
        detailCertification: payload.data,
      };

    case ACTION_TYPES.CERTIFICATION_GET_DETAIL_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetail: 2,
        },
        error,
      };

    // reset cert
    case ACTION_TYPES.CERTIFICATION_RESET_STATE:
      return {
        ...state,
        status: {
          ...state.status,
          ...initialState.status,
        },
        error: initialState.error,
      };
    default:
      return state;
  }
}
